exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sectorsRow{height:30vh}.sectorsRow2{height:15vh}", ""]);

// exports
